import Model from "./base/model";

class SimulationTableFile extends Model{
  resourceName() {
    return "simulation_tables_files";
  }

  fields() {
    return {
      simulation_table_id: "",
      user_id: "",
      approval: "",
      path: "",
      name: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableFile();
